<template>
<div>
    <h1 :class="selected ? 'text-sm pt-2' : 'text-xl pt-0.5 font-bold'"> {{$t('form.ean-products.identification_du_produit')}} </h1>
    <sav-fold-card v-model="open" class="mt-4" :close-button="false" :can-open="canOpen"  :id="$options.name">
        <template v-slot:close>
            <template v-if="selected">
                <div class="font-bold">{{selected.description}}</div>
                <div class="text-sm font-light">{{selected.ean}}</div>
            </template>
        </template>
        <template v-slot:open>
            <sav-spinner v-if="loading" :size="10" />
            <div v-if="data && data.products">
                <div v-for="(product, productIndex) in data.products" :key="'product-ean-' + productIndex" class="p-6" :class="productIndex < data.products.length - 1 ? 'border-b border-gray-200 mb-2' : ''">
                    <div class="flex items-center justify-between">
                        <div>
                            <div class="font-bold">{{product.description}}</div>
                            <div class="text-sm font-light">{{product.ean}}</div>
                        </div>
                        <button @click="end(product)" class="px-3 py-2 mt-3 text-sm font-light text-gray-700 duration-200 bg-gray-200 border-gray-200 rounded hover:bg-gray-300"> {{$t('form.ean-products.selectionner')}} </button>
                    </div>
                </div>
            </div>
            <div v-if="data && data.products && data.products.length <= 0"> {{$t('form.ean-products.aucun_produit_trouve')}}
            </div>
        </template>
    </sav-fold-card>
</div>
</template>

<script>
import FormCardExtension from '@/extends/FormCardExtension'
import apiService from '@/services/api.service'

export default {
    name: 'ean-products',
    extends: FormCardExtension,

    methods: {
        async init() {
            // Check if data
            if (this.$formTool.getFormData(this.$options.name)) {
                this.nextBlock = await this.getNextBlock()
                this.selected = JSON.parse(JSON.stringify(this.$formTool.getFormData(this.$options.name)))
            }

            // Check can open card after set-case
            this.removeOpenAfterSetCase()

            this.data = this.$formTool.getFormData('find-ticket')
        },

        async end(callbackData) {
            this.$formTool.addFormData(this.$options.name, callbackData)
            this.$formTool.addFormData('device', [
                    {
                        value: {
                            id: callbackData.id_app,
                            Modele: callbackData.description
                        }
                    }
            ])
            this.nextBlock = await this.getNextBlock()
            if (this.selected) {
                this.$emit('update', this.$options.name)
            }
            this.selected = JSON.parse(JSON.stringify(callbackData))
        },

        async getBdc() {
            let responseBdc = await apiService.post('getbdc', {
                id_app: this.$formTool.getFormData(this.$options.name).id_app
            })
            return responseBdc.data.posts
        },
        async getBdc2() {
            let responseBdc = await apiService.post('getbdc2', {
                id_app: this.$formTool.getFormData(this.$options.name).id_app
            })
            return responseBdc.data.posts
        },

        async getNextBlock() {
            // Check code_panne
            let responseCodePanne = await apiService.post('getcodesymptome', {
                id_app: this.$formTool.getFormData('device')[0].value.id
            })
            if (responseCodePanne.data.posts.code_symptome && responseCodePanne.data.posts.code_symptome.length > 0) {
                this.$formTool.addFormData('code_symptome', responseCodePanne.data.posts.code_symptome)
                return this.$formTool.blockData(this.$options.name).next.code_panne
            }

            let responseBdc = await this.getBdc()
            this.$formTool.addFormData('bdc', responseBdc)
            if (responseBdc.spareka) {
                return this.$formTool.blockData(this.$options.name).next.spareka
            } else if (responseBdc.post && responseBdc.post.length > 0) {
                let responseBdc2 = await this.getBdc2()
                this.$formTool.addFormData('bdc2', responseBdc2)
                if (this.$companyTool.confFile().chatbot == '1') {
                    return this.$formTool.blockData(this.$options.name).next.newOwnTchat
                } else {
                    return this.$formTool.blockData(this.$options.name).next.ownTchat
                }
            }
            return this.$formTool.blockData(this.$options.name).next.continue
        }
    },

    mounted() {
        this.init()
    }
}
</script>



// WEBPACK FOOTER //
// src/processes/cards/shop/EanProductsCard.vue